// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__205dM","error":"InputSecondary_error__1DcKG","disabled":"InputSecondary_disabled__deTA2"};